import _ from 'lodash';
import template from 'text!./templates/Select.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            item: '&'
        },
        template: template,
        link: function link($scope) {
            $scope.$watch('item()', function (item) {
                $scope.fakeVM = {
                    set value(val) {
                        item.setValue(val.code);
                    },

                    get value() {
                        return _.find(this.options, function (opt) {
                            return opt.code === item.getValue();
                        });
                    },

                    get options() {
                        return item.getAvailableValues() || [];
                    }
                };
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/Select.js
// module id = 103
// module chunks = 0